import { logEvent } from '@/libs/log'
import { useEffect } from 'react'

/** once값이 true라면 동일한 프로퍼티를 가진 이벤트는 최초 1회만 로깅 */
const usePageView = (
  eventName: string,
  eventProperties?: Record<string, any>,
  isReady = true,
  once = true,
) => {
  useEffect(() => {
    if (!isReady) return

    logEvent({
      eventName,
      properties: eventProperties,

      withSource: true,
      once,
    })
  }, [eventName, eventProperties, once, isReady])
}

export default usePageView
